<template>
  <x-modal size="medium">
    <div class="x-modal__contents">
      <ys-text type="body1">
        Your browser or computer do not support required features needed to
        power the map and may not work as expected.
      </ys-text>

      <ys-link type="link0">
        <a
          href="https://onxmapssupport.zendesk.com/hc/en-us/articles/4414111261581-Web-Browser-does-not-support-MapBoxGL"
          target="_blank"
          rel="noopener noreferrer"
          class="support-link"
        >
          onX Mapbox Support FAQs
        </a>
      </ys-link>

      <ys-link type="link0">
        <a
          href="https://get.webgl.org/webgl2"
          target="_blank"
          rel="noopener noreferrer"
          class="support-link"
        >
          Check WebGL2 Support
        </a>
      </ys-link>
    </div>
    <ys-button
      variant="primary"
      size="small"
      class="close-btn"
      @click.stop="$emit('close')"
    >
      Close
    </ys-button>
  </x-modal>
</template>

<script setup lang="ts">
import xModal from '@/components/shared/x-modal/index.vue'
import '@onxmaps/yellowstone-ui/ys-button'
import '@onxmaps/yellowstone-ui/ys-text'
import '@onxmaps/yellowstone-ui/ys-link'

interface Emits {
  (e: 'close'): void
}

defineEmits<Emits>()
</script>

<style lang="scss" scoped>
.support-link {
  display: block;
  padding: var(--ys-spacing-50) 0;
}
.close-btn {
  margin-right: var(--ys-spacing-50);
  margin-bottom: var(--ys-spacing-50);
  margin-left: var(--ys-spacing-50);
}
</style>
